import { render, staticRenderFns } from "./AppSyncState.vue?vue&type=template&id=0c2fc46b&"
import script from "./AppSyncState.vue?vue&type=script&lang=js&"
export * from "./AppSyncState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports